//LOGIN
export const LOGIN = "/auth/admin/login";
export const VERIFY_TOKEN = "/auth/verify-token/";
export const FORGOT = "/auth/forget-password";
export const RESET = "/auth/reset-password/";
export const GET_PROFILE = "/auth/profile";
export const UPDATE_PROFILE = "/auth/update-profile";
export const CHANGE_PROFILE = "/auth/change-password";
export const UPDATE_BANK = "/auth/update-bank";
export const GET_BANK = "/auth/get-bank";
export const CHANGE_EMAIL = "/auth/change-email";
export const OTP_VERIFY = "/auth/email/verify-OTP";

//Email
export const EMAIL = "/admin/email";
export const EMAIL_LIST = "/admin/email";
export const EMAIL_GET = "/admin/email/";
export const EMAIL_UPDATE = "/admin/email/";
export const EMAIL_DELETE = "/admin/email/";
export const EMAIL_STATUS = "/admin/email/change-status/";



export const GET_NOTIFICATION_TEMPLATES = "/admin/notification/template/";
export const UPDATE_NOTIFICATION_TEMPLATE = "/admin/notification/template/";

//Notification
export const Notification = "/admin/notification";
export const Notification_LIST = "/admin/notification";
export const Notification_STATUS = "/admin/notification/change-status/";

//Notification
export const NOTIFICATION = "/admin/notification";
export const NOTIFICATION_ADMIN = "/admin/notification/my-list";
export const NOTIFICATION_LIST = "/admin/notification/list";
export const NOTIFICATION_UPDATE = "/admin/notification/";
export const NOTIFICATION_GET = "/admin/notification/";
export const NOTIFICATION_DELETE = "/admin/notification/";
export const NOTIFICATION_STATUS = "/admin/notification/change-status/";
export const NOTIFICATION_ADMIN_DELETE = "/common/notification";
export const NOTIFICATION_ADMIN_READ = "/common/notification-read";

//Customer
export const CUSTOMER = "/admin/customer";
export const CUSTOMER_LIST = "/admin/customer";
export const CUSTOMER_UPDATE = "/admin/customer/";
export const CUSTOMER_DELETE = "/admin/customer/";
export const CUSTOMER_STATUS = "/admin/customer/change-status/";
export const CUSTOMER_STATS = "/admin/customer/get-stats/";

//Customer
export const CITY = "/admin/city/";
export const CITY_LIST = "/admin/city";
export const GET_CITY_LIST = "/admin/city/get-city";
export const CITY_UPDATE = "/admin/city/";
export const CITY_DELETE = "/admin/city/";
export const CITY_STATUS = "/admin/city/change-status/";
export const CITY_ADD = "/admin/city";

//Graduation
export const GRADUATION = "/admin/graduation/create";
export const GRADUATION_LIST = "/admin/graduation/list";
export const GRADUATION_DELETE = "/admin/graduation/delete/";


//Exam
export const EXAM = "/admin/exam/create";
export const EXAM_LIST = "/admin/exam/list";
export const ELIGIBLE_LIST = "/admin/exam/eligibles/";
export const ALL_ELIGIBLE = "/admin/exam/all-eligibles";
export const UPDATE_ELIGIBLE_NOTE = "/admin/exam/eligible-note";
export const EXAM_UPDATE = "/admin/exam/update/";
export const EXAM_DELETE = "/admin/exam/delete/";

//Result/Graduation
export const RESULT = "/admin/graduation/create";
export const RESULT_LIST = "/admin/graduation/list";

//Student Progress
export const LIST_PROGRESS = "/admin/booking/progress";
export const GRANT_KYU = "/admin/booking/grant-kyu";
export const VIEW_PROGRESS = "/admin/booking/view-progress/";

//Branch
export const BRANCH = "/admin/branch";
export const BRANCH_LIST = "/admin/branch";
export const BRANCH_UPDATE = "/admin/branch/";
export const BRANCH_DELETE = "/admin/branch/";
export const BRANCH_STATUS = "/admin/branch/change-status/";
export const BRANCH_ACCESS_STATUS = "/admin/branch/branch-access/";
export const BRANCH_INFO = "/admin/branch/get-stats/";

//Employee
export const EMPLOYEE = "/admin/employee";
export const EMPLOYEE_LIST = "/admin/employee";
export const EMPLOYEE_AND_BRANCH_ADMIN_LIST = "/admin/employee/trainer-branch";
export const EMPLOYEE_UPDATE = "/admin/employee/";
export const EMPLOYEE_DELETE = "/admin/employee/";
export const EMPLOYEE_STATUS = "/admin/employee/change-status/";
export const EMPLOYEE_VIEW = "/admin/employee/delete/";

// class
export const CLASS = "/admin/class";
export const CLASS_LIST = "/admin/class";
export const LIST_CLASSES = "/admin/class/class-branch";
export const CLASS_UPDATE = "/admin/class/";
export const CLASS_STATUS = "/admin/class/change-status/";
export const CLASS_DELETE = "/admin/class/delete/";
export const CLASS_SLOTS = "/admin/class/get-slots";
export const UPDATE_SLOT = "/admin/class/update-slot";

//transaction
export const TRANSACTION = "/admin/transaction";
export const TRANSACTION_LIST = "/admin/transaction";
export const TRANSACTION_GRAPH = "/admin/transaction/graph";

// Banner
export const BANNER = "/admin/banner";
export const BANNER_LIST = "/admin/banner";
export const BANNER_UPDATE = "/admin/banner/";
export const BANNER_DELETE = "/admin/banner/delete/";
export const BANNER_STATUS = "/admin/banner/change-status/";

// subscription
export const SUBSCRIPTION = "/admin/subscription";
export const SUBSCRIPTION_LIST = "/admin/subscription";
export const SUBSCRIPTION_UPDATE = "/admin/subscription/";
export const SUBSCRIPTION_DELETE = "/admin/subscription/delete/";
export const SUBSCRIPTION_STATUS = "/admin/subscription/change-status/";
export const SUBSCRIPTION_GET = "/admin/subscription/";

//subscription request
export const SUBSCRIPTION_REQUEST = "/admin/subscriptionrequest";
export const SUBSCRIPTION_REQUEST_LIST = "/admin/subscriptionrequest";
export const SUBSCRIPTION_REQUEST_UPDATE = "/admin/subscriptionrequest/";
export const SUBSCRIPTION_REQUEST_ACCEPT = "/admin/subscriptionrequest/approve-request/";
export const SUBSCRIPTION_REQUEST_REJECT = "/admin/subscriptionrequest/reject-request/";

// Belt
export const BELT = "/admin/belt";
export const BELT_LIST = "/admin/belt";
export const BRANCH_BELT_LIST = "/admin/belt/branch-belt";
export const BELT_UPDATE = "/admin/belt/";
export const BELT_DELETE = "/admin/belt/delete/";
export const BELT_STATUS = "/admin/belt/change-status/";

// Kyu
export const KYU = "/admin/kyu";
export const KYU_LIST = "/admin/kyu";
export const KYU_UPDATE = "/admin/kyu/";
export const KYU_DELETE = "/admin/kyu/delete/";
export const KYU_STATUS = "/admin/kyu/change-status/";
export const GET_KYU_BY_BELT = "admin/kyu/kyu-list/";

// Report
export const REPORT = "/admin/report";
export const REPORT_LIST = "/admin/report";
export const REPORT_UPDATE = "/admin/report/";
export const REPORT_REPLY = "/admin/report/reply";
export const REPORT_DELETE = "/admin/report/";
export const REPORT_STATUS = "/admin/report/change-status/";

//tutor
export const TUTOR = "/admin/tutor";
export const TUTOR_LIST = "/admin/tutor";
export const TUTOR_UPDATE = "/admin/tutor/";
export const TUTOR_BY_COURSE = "/admin/tutor/course/";
export const TUTOR_DELETE = "/admin/tutor/";
export const TUTOR_STATUS = "/admin/tutor/change-status/";
export const TUTOR_WALLET_UPDATE = "/admin/tutor/wallet-update/";
export const TUTOR_REVIEW = "/admin/tutor/review/";
export const TUTOR_CHAT = "/admin/tutor/create-chat";

//role
export const ROLE = "/admin/role";
export const ROLE_LIST = "/admin/role";
export const ROLE_UPDATE = "/admin/role/";
export const ROLE_DELETE = "/admin/role/";
export const ROLE_STATUS = "/admin/role/change-status/";

//dashboard
export const TOTAL_COUNT = "/admin/dashboard/count";
export const LEADERBOARD_DATA = "/admin/dashboard/leaderboard";
export const GRAPH_DATA = "/admin/dashboard/graph-data";
export const JOINED_BET = "/common/joined-bet/";
export const CREATED_BET = "/common/created-bet/";

//booking
export const ATTENDANCE_LIST = "/admin/booking/attendance";
export const BOOKING_LIST = "/admin/booking";
export const BOOKING_STATUS = "/admin/booking/status-change/";
export const CLASS_RESERVATIONS = "/admin/booking/reservations";
export const CANCEL_BOOKING = "/admin/booking/cancel";

//course
export const COURSE = "/admin/course";
export const COURSE_LIST = "/admin/course";
export const COURSE_UPDATE = "/admin/course/";
export const COURSE_TRENDING = "/admin/course/change-trending/";
export const COURSE_DELETE = "/admin/course/";
export const COURSE_STATUS = "/admin/course/change-status/";

//Content
export const CONTENT = "/admin/content";
export const CONTENT_LIST = "/admin/content";
export const CONTENT_UPDATE = "/admin/content/";
export const CONTENT_GET = "/admin/content/";
export const CONTENT_DELETE = "/admin/content/";
export const CONTENT_STATUS = "/admin/content/change-status/";

//Event
export const EVENT = "/admin/event";
export const EVENT_LIST = "/admin/event";
export const EVENT_UPDATE = "/admin/event/";
export const EVENT_GET = "/admin/event/";
export const EVENT_DELETE = "/admin/event/";
export const EVENT_STATUS = "/admin/event/change-status/";


export const GET_BELTS = "/admin/belt/branch-belts";

// Common
export const GET_KYUS = "/common/kyus";
export const GET_All_BELT = "/common/belts";
export const GET_TRAINERS = "/common/trainers";
export const GET_EMPLOYEES = "/common/employees";
export const GET_STUDENTS = "/common/users";
export const GET_STUDENT = "/common/student-list";
export const GET_CLASSES = "/common/all-classes";
export const GET_BRANCHES = "/common/branches";
export const STUDENT_LIST = "/common/students/list/";
